import { SET_FLAGS } from './FlagsConstants'

const initialState = {
  flags: {},
  flagsFetched: false,
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export default function flagsReducer(state = initialState, action) {
  switch (action.type) {
    case SET_FLAGS:
      return {
        ...state,
        flags: action.payload,
        flagsFetched: true,
      }
    default:
      return state
  }
}
